export default [function () {
    this.availability = [];
    this.singleDays = [];
    this.singleTimes = [];

    return {
        resetAvailability: () => {
            this.availability = [];
        },
        getAvailability: () => {
            return this.availability;
        },
        setAvailability: (availability) => {
            this.availability = availability;
        },
        hasAvailability: () => {
            return !!this.availability.length;
        },
        resetSingleDays: () => {
            this.singleDays = [];
        },
        getSingleDays: () => {
            return this.singleDays;
        },
        setSingleDays: (days) => {
            this.singleDays = days;
        },
        hasSingleDays: () => {
            return !!this.singleDays.length;
        },
        resetSingleTimes: () => {
            this.singleTimes = [];
        },
        getSingleTimes: () => {
            if (this.singleTimes === false){
                return [];
            }
            return this.singleTimes;
        },
        setSingleTimes: (times) => {
            this.singleTimes = times;
        },
        hasSingleTimes: () => {
            if (this.singleTimes === false){
                return true;
            }
            return !!this.singleTimes.length;
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/availability/services/availability.service.js